<template>
	<div style="height: inherit">
		<fetch-json :url="urlRegulation" v-if="searchLocation">
			<template slot-scope="{json:regs,loading}">
				<custom-scroll v-if="!loading && regs && regs.length">
					<div class="tab-padding test">
						<urban-terzone-regulation v-for="reg in regs" :regulation="reg" :key="reg.key"></urban-terzone-regulation>						
					</div>
				</custom-scroll>
				<no-data-place-holder v-else></no-data-place-holder>
			</template>
		</fetch-json>
		<no-data-place-holder v-else></no-data-place-holder>
	</div>
</template>
<script>
	import UrbanTerzoneRegulation from "./UrbanTerzoneRegulation";
	import { mapState } from 'vuex';
	export default {
		props: {
			projectSchema: {
				type: String,
				required: true
			}
		},
		components: {
			UrbanTerzoneRegulation
		},
		computed: {
			...mapState([
				'searchLocation'
			]),
			urlRegulation() {
				return `v1/spatialsearch/${this.projectSchema}/urbanterzoneregulation/${this.searchLocation.point.x}/${this.searchLocation.point.y}`;
			}			
		},
	}
</script>